module.exports = __webpack_public_path__ + "static/media/coop_icon.6f268f5b.png";